<template>
  <div class="contentBox">
    <div class="logo-item clear">
      <div class="logo-txt">
        <i class="icon icon-logo"></i>
        <p>Speakio</p>
      </div>
      <div class="logo-nav">
        <button class="btn btn-nav btn-nav1 ">
          <router-link to="/">Home</router-link>
        </button>
        <button class="btn btn-nav btn-nav2 select">
          <router-link to="/blog">Blog</router-link>
        </button>
        <button class="btn btn-nav btn-nav3">
          <router-link to="/contact">Contact</router-link>
        </button>
      </div>
    </div>

  
    <div class="listDetail" v-if="detailType">
      <div class="detail-item">
        <p class="detail-title">{{detailData.title}}</p>
        <img :src="detailData.image" alt="">
        <!-- <p class="detail-content">{{detailData.content}}</p> -->
        <p class="detail-content" v-html="detailData.content"></p>
      </div>
      <div class="item item1">
        <div class="item-title item-title1">Polish your presentation skills with zero hassle.</div>
        <div class="item-title item-title2">Record your voice. upload it. and get expert-level analysis from our Al coach instantly.</div>
        <div class="item-title-upload">
          <p>Get Speakio for free</p>
          <div class="item-title-upliad-app">
            <div class="item-app item-Ios">
              <i class="icon icon-ios"></i>
              <p>App Store</p>
                <img :src="require('@/assets/images/upload-ios.png')" alt="" srcset="">
            </div>
            <div class="item-app item-Android">
              <i class="icon icon-Android"></i>
              <p>Play Store</p>
                <img :src="require('@/assets/images/upload-android.png')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list" v-else>
      <div class="list-item" v-for="(item,index) in dataList" :key="index" @click="lookDetail(item)">
        <div class="list-img">
          <img :src="item.image" alt="">
          <i class="icon icon1"></i>
        </div>
        <div class="list-txt">
          {{item.title}}
        </div>
      </div>
      <div class="block pageBox clear">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="obj.page"
          :page-size="1"
          layout="prev, pager, next, jumper"
          :total="totalPage">
        </el-pagination> 
      </div>
    </div>


    <footer class="footer">
      <div class="footer-btnBox">
        <a>Contact</a>
        <a>Terms of Service</a>
        <a>Privacy Policy</a>
      </div>
      <p>Copyright @ 2026 Speakio. All Rights Reserved</p>
    </footer>
  </div>
</template>

<script>
import {getWebNoticeList,getWebNoticeDetail} from "@/assets/js/api";
export default {
  name: "index",
  data() {
    return {
      obj:{
        page:1,
        rows:10
      },
      dataList:[],
      url:'https://speakiopic.zens10.com/',
      detailData:"",
      detailType:false,
      totalPage:0,
      id:''
    };
  },
  mounted(){
    // this.getList();
    this.id = this.$route.query.id;
    this.lookDetail(this.id)
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    async getList(){
      var that = this;
      try {
        const response = await getWebNoticeList(this.obj);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            item.image = that.url + item.image;
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async lookDetail(id){
      var that = this;
      try {
        const response = await getWebNoticeDetail({id:id});
        if(response.code == 200){
          response.data.image = that.url + response.data.image;
          that.detailData = response.data;
          that.detailType = true;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    
  }
};
</script>
<style scoped>
  .contentBox{
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #E5CFFF;
  }

  .logo-item{
    display: block;
    box-sizing: border-box;
    padding: 10px 100px;
    background-color: rgba(255, 255, 255, .43);
  }

  .logo-item .logo-txt{
    float: left;
  }

  .logo-item .logo-txt .icon-logo{
    background-image: url(~@/assets/images/index-icon10.png);
    width: 60px;
    height: 60px;
    background-size: 60px 60px;
    display: inline-block;
    vertical-align: middle;
  }

  .logo-item .logo-txt p{
    font-size: 18px;
    color: #000000;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
  }

  .logo-item .logo-nav{
    float: right;
  }

  .logo-item .logo-nav a{
    text-decoration: none;
    color: #333333;
  }

  .logo-item .logo-nav .btn{
    font-size: 18px;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 15px 0;
    margin-left: 50px;
  }
  
  .logo-item .logo-nav .btn.select{
    color: #6E2FFF;
    border-bottom: solid 3px #6E2FFF;
  }

  .item1{
    background-color: #E5CFFF;
    box-sizing: border-box;
    padding: 40px 100px;
  }

  .item-title-upload{
    background-color: #fff;
    border-radius: 40px;
    box-sizing: border-box;
    padding-bottom: 70px;
    /* margin-top: 128px; */
  }

  .item-title-upload p{
    background-color: #CDB8FF;
    width: 328px;
    height: 74px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    color: #000000;
    font-size: 24px;
    box-sizing: border-box;
    padding: 20px 30px;
    margin: 0 auto;
    text-align: center;
  }

  .item-title-upliad-app{
    font-size: 0;
    margin-top: 40px;
    text-align: center;
    padding: 0 50px;
    box-sizing: border-box;
  }

  .item-title-upliad-app .item-app{
    width: 297px;
    height: 95px;
    background-color: #333333;
    border-radius: 20px;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 25px 0;
    margin: 0 10px;
    position: relative;
  }

  .item-title-upliad-app .item-app .icon{
    background-image: url(~@/assets/images/index-icon3.png);
    width: 45px;
    height: 45px;
    background-size: 45px 45px;
    display: inline-block;
    vertical-align: top;
  }

  .item-title-upliad-app .item-app .icon-ios{
    background-image: url(~@/assets/images/index-icon2.png);
  }

  .item-title-upliad-app .item-app p{
    font-size: 32px;
    color: #FFFFFF;
    display: inline-block;
    vertical-align: top;
    background-color: transparent;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
  }

  .item-title-upliad-app .item-app img{
    width: 200px;
    height: 216px;
    position: absolute;
    bottom: -226px;
    left: 48px;
    /* display: none; */
    opacity: 0;
  }

  .item-title-upliad-app .item-app:hover img{
    /* display: block; */
    opacity: 1;
    transition: all 1s;
  }

  footer{
    background-color: #260054;
    display: block;
    text-align: center;
    box-sizing: border-box;
    padding: 80px 0;
  }

  footer .footer-btnBox{
    font-size: 0;
    text-align: center;
    margin-bottom: 30px;
  }

  footer .footer-btnBox a{
    color: #FFFFFF;
    font-size: 18px;
    display: inline-block;
    vertical-align: top;
    border-right: solid 1px #fff;
    padding: 0 10px;
    text-decoration: none;
  }

  footer .footer-btnBox a:last-child{
    border-right: none;
  }

  footer p{
    color: #FFFFFF;
    font-size: 16px;
  }

  footer p:nth-of-type(2){
    margin: 30px 0;
  }

  .list-item {
    background-color: #fff;
    border-radius: 40px;
    margin: 40px 100px;
    display: block;
    box-sizing: border-box;
    padding: 40px 100px;
    position: relative;
  }

  .list-item .list-img{
    display: inline-block;
    vertical-align: middle;
    width: 307px;
  }

  .list-item .list-img img{
    width: 227px;
    height: 310px;
    display: block;
    margin: 0 40px;
    position: relative;
    z-index: 2;
  }

  .list-item .icon1{
    background-image: url(~@/assets/images/icon1.png);
    width: 307px;
    height: 81px;
    background-size: 307px 81px;
    display: block;
    margin-top: -81px;
    z-index: 1;
  }

  .list-item .list-txt{
    display: inline-block;
    vertical-align: middle;
    color: #000000;
    font-size: 34px;
    font-weight: bold;
    margin-left: 60px;
    width: calc( 100% - 370px );
  }

  .listDetail .detail-item{
    box-sizing: border-box;
    padding: 100px 100px 40px;
  }

  .listDetail{
    background-color: #fff;
  }

  .detail-title{
    font-size: 34px;
    color: #000000;
    font-weight: bold;
    margin-bottom: 40px;
  }

  .listDetail img{
    width: 700px;
    display: block;
  }

  .detail-content{
    font-size: 24px;
    color: #333333;
    margin-top: 40px;
  }

  .listDetail .item-title{
    display: block;
    text-align: center;
    color: #000000;
  }

  .listDetail .item-title1{
    font-size: 36px;
    margin-bottom: 20px;
  }

  .listDetail .item-title2{
    font-size: 24px;
    margin-bottom: 80px;
  }

  .pageBox{
    display: block;
    float: none;
    text-align: right;
    margin: 0px 30px 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/detail.vue